import { axiosInstance } from '../common/api';

export const createSection = (data) =>
  new Promise((resolve, reject) => {
    axiosInstance
      .post('/section', data)
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });

export const getSectionsByProjectId = (projectId, criteria = {}) => {
  const { pageNumber, orderBy, order } = criteria;
  let url = `/section?`;
  if (pageNumber) url += `pageNumber=${pageNumber + 1}&`;
  else url += `pageNumber=all&`;
  if (projectId) url += `projectId=${projectId}&`;
  if (orderBy) url += `orderBy=${orderBy}&`;
  if (order) url += `order=${order}&`;
  return new Promise((resolve, reject) => {
    axiosInstance
      .get(url)
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });
};

export const updateSection = (sectionId, data) =>
  new Promise((resolve, reject) => {
    axiosInstance
      .put(`/section/${sectionId}`, data)
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });

export const deleteSection = (sectionId) =>
  new Promise((resolve, reject) => {
    axiosInstance
      .delete(`/section/${sectionId}`)
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });
